/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Notifications';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const NotificationsIcon = withMuiAdapter(Base, 'Notifications');
